import { css, Global } from '@emotion/react';
import emotionReset from 'emotion-reset';

export const cssReset = css`
  ${emotionReset}

  *, *::after, *::before {
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
  }

  body {
    font-family: var(--font-family-sans-serif);
    background-color: var(--colour-white);
    color: var(--colour-deep-space);
  }

  button {
    /* font-family: var(--font-family-sans-serif); */
  }
`;

const GlobalStyles = () => <Global styles={cssReset} />;

export { GlobalStyles };
